/**
 * JettProof Mega Menu v2 — JavaScript
 *
 * Hover-intent for desktop, accordion for mobile drawer,
 * keyboard navigation, overlay control, ARIA attributes.
 *
 * Zero dependencies. Pure vanilla JS.
 */
(function () {
  'use strict';

  // ── Desktop Mega Menu ──────────────────────────────────────────────
  const HOVER_DELAY_IN = 120;   // ms before opening
  const HOVER_DELAY_OUT = 250;  // ms before closing (grace period)

  let activeTrigger = null;
  let hoverInTimer = null;
  let hoverOutTimer = null;
  const overlay = document.getElementById('MegaMenuOverlay');

  function openPanel(trigger) {
    if (activeTrigger && activeTrigger !== trigger) {
      closePanel(activeTrigger);
    }
    activeTrigger = trigger;
    trigger.classList.add('is-active');

    const panel = trigger.querySelector('.mm-panel, .mm-simple-dropdown');
    if (panel) {
      panel.classList.add('is-active');
      panel.setAttribute('aria-hidden', 'false');
    }

    if (overlay && trigger.querySelector('.mm-panel')) {
      overlay.classList.add('is-active');
    }
  }

  function closePanel(trigger) {
    if (!trigger) return;
    trigger.classList.remove('is-active');

    const panel = trigger.querySelector('.mm-panel, .mm-simple-dropdown');
    if (panel) {
      panel.classList.remove('is-active');
      panel.setAttribute('aria-hidden', 'true');
    }

    if (overlay) {
      overlay.classList.remove('is-active');
    }

    if (activeTrigger === trigger) {
      activeTrigger = null;
    }
  }

  function closeAll() {
    document.querySelectorAll('.mm-trigger.is-active').forEach(function (t) {
      closePanel(t);
    });
  }

  function initDesktop() {
    var triggers = document.querySelectorAll('.mm-trigger');

    triggers.forEach(function (trigger) {
      // Hover in
      trigger.addEventListener('mouseenter', function () {
        clearTimeout(hoverOutTimer);
        clearTimeout(hoverInTimer);
        hoverInTimer = setTimeout(function () {
          openPanel(trigger);
        }, HOVER_DELAY_IN);
      });

      // Hover out
      trigger.addEventListener('mouseleave', function () {
        clearTimeout(hoverInTimer);
        hoverOutTimer = setTimeout(function () {
          closePanel(trigger);
        }, HOVER_DELAY_OUT);
      });

      // Click on top-level link (for touch devices seeing desktop layout)
      var topLink = trigger.querySelector(':scope > .site-nav__link');
      if (topLink) {
        topLink.addEventListener('click', function (e) {
          var panel = trigger.querySelector('.mm-panel, .mm-simple-dropdown');
          if (!panel) return; // let normal links through

          // If there's a real URL (not just '#'), allow second tap to navigate
          if (trigger.classList.contains('is-active')) {
            return; // allow navigation
          }

          e.preventDefault();
          openPanel(trigger);
        });
      }

      // Keyboard: focus on trigger opens, Escape closes
      trigger.addEventListener('focusin', function () {
        clearTimeout(hoverOutTimer);
        clearTimeout(hoverInTimer);
        openPanel(trigger);
      });

      trigger.addEventListener('focusout', function (e) {
        // Only close if focus left the trigger entirely
        requestAnimationFrame(function () {
          if (!trigger.contains(document.activeElement)) {
            closePanel(trigger);
          }
        });
      });
    });

    // Overlay click closes mega menu
    if (overlay) {
      overlay.addEventListener('click', closeAll);
    }

    // Escape key closes everything
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeAll();
        if (activeTrigger) {
          var link = activeTrigger.querySelector(':scope > .site-nav__link');
          if (link) link.focus();
        }
      }
    });
  }

  // ── Mobile Drawer ──────────────────────────────────────────────────
  function initMobileDrawer() {
    var drawer = document.getElementById('MegaMenuDrawer');
    var drawerOverlay = document.getElementById('MegaMenuDrawerOverlay');
    var openBtns = document.querySelectorAll('.js-mm-drawer-open');
    var closeBtns = document.querySelectorAll('.js-mm-drawer-close');

    if (!drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      if (drawerOverlay) drawerOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      // Focus trap: focus first item
      var firstFocusable = drawer.querySelector('a, button');
      if (firstFocusable) firstFocusable.focus();
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      if (drawerOverlay) drawerOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', openDrawer);
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });

    if (drawerOverlay) {
      drawerOverlay.addEventListener('click', closeDrawer);
    }

    // Escape closes drawer
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    // Accordion toggles
    var toggles = drawer.querySelectorAll('.mm-drawer-item__toggle');
    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var item = toggle.closest('.mm-drawer-item');
        if (!item) return;

        var isExpanded = item.classList.contains('is-expanded');

        // Optional: close other open accordions
        drawer.querySelectorAll('.mm-drawer-item.is-expanded').forEach(function (open) {
          if (open !== item) {
            open.classList.remove('is-expanded');
            var sub = open.querySelector('.mm-drawer-sub');
            if (sub) sub.style.maxHeight = '0px';
            var btn = open.querySelector('.mm-drawer-item__toggle');
            if (btn) btn.setAttribute('aria-expanded', 'false');
          }
        });

        if (isExpanded) {
          item.classList.remove('is-expanded');
          var sub = item.querySelector('.mm-drawer-sub');
          if (sub) sub.style.maxHeight = '0px';
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('is-expanded');
          var sub = item.querySelector('.mm-drawer-sub');
          if (sub) sub.style.maxHeight = sub.scrollHeight + 'px';
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // Touch: swipe left to close
    var touchStartX = 0;
    drawer.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    drawer.addEventListener('touchend', function (e) {
      var touchEndX = e.changedTouches[0].clientX;
      if (touchStartX - touchEndX > 80) {
        closeDrawer();
      }
    }, { passive: true });
  }

  // ── Init ───────────────────────────────────────────────────────────
  function init() {
    initDesktop();
    initMobileDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
